import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { DashboardThemeProvider, useDashboardTheme } from '../../../context/DashboardThemeContext';
import Sidebar from '../Sidebar';
import Header from '../Header';
import Settings from './Settings';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../../store/authSlice';

const SettingsPageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${(p) => p.theme.pageBg};
  color: ${(p) => p.theme.textPrimary};
  transition: background 0.2s ease, color 0.2s ease;
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`;

const SettingsPageInner = () => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('settings');
  const { mode } = useDashboardTheme();

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <SettingsPageContainer>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      <MainContent>
        <Header user={user} onLogout={handleLogout} />
        <ContentArea>
          <Settings themeMode={mode} />
        </ContentArea>
      </MainContent>
    </SettingsPageContainer>
  );
};

const SettingsPage = () => (
  <DashboardThemeProvider>
    <SettingsPageInner />
  </DashboardThemeProvider>
);

export default SettingsPage;
